module.exports = __webpack_public_path__ + "img/industry_2.685ddcdd.png";